import { render, staticRenderFns, recyclableRender, components } from "./store-info.vue?vue&type=template&id=54dfab99&scoped=true&"
var renderjs
import script from "./store-info.vue?vue&type=script&lang=js&"
export * from "./store-info.vue?vue&type=script&lang=js&"
import style0 from "./store-info.vue?vue&type=style&index=0&id=54dfab99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfab99",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/store-info/store-info.vue"
export default component.exports